package app.nestbridge.feature.invitations.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class InvitationConfirmationScreen(
    val invitationId: String,
    val mode: Mode,
) : Screen {
    enum class Mode { Accept, Decline }
}

data class InvitationConfirmationState(
    val mode: InvitationConfirmationScreen.Mode,
    val eventSink: (InvitationConfirmationEvent) -> Unit = {},
) : CircuitUiState

sealed interface InvitationConfirmationEvent {
    data object Confirm : InvitationConfirmationEvent
    data object DecideLater : InvitationConfirmationEvent
    data object ShowTerms : InvitationConfirmationEvent
    data object ShowPrivacy : InvitationConfirmationEvent
}

@Parcelize
data class InvitationResult(
    val invitationId: String,
    val decision: Decision,
) : PopResult {
    enum class Decision { Accepted, Declined, Cancelled }
}
